import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Statistic, Button, Table, Tag, Space } from 'antd';
import {
  ThunderboltOutlined,
  CheckCircleOutlined,
  PoweroffOutlined,
  TeamOutlined,
  CloudUploadOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { inverter_api } from '../api/inverter-api';
import { user_api } from '../api/user-api';
import { firmware_api } from '../api/firmware-api';

export default function Home() {
  const navigate = useNavigate();
  const [deviceStats, setDeviceStats] = useState({});
  const [userStats, setUserStats] = useState({});
  const [devices, setDevices] = useState([]);
  const [dspLatest, setDspLatest] = useState(null);

  useEffect(() => {
    inverter_api.getInverterStatistics().then((res) => {
      if (res.success) setDeviceStats(res.data || {});
    }).catch(() => {});

    inverter_api.getAllInverters({ limit: 8 }).then((res) => {
      if (res.success) setDevices(res.data || []);
    }).catch(() => {});

    user_api.getStatistics().then((res) => {
      if (res.success) setUserStats(res.data || {});
    }).catch(() => {});

    firmware_api.getLatest('dsp-esp32').then((res) => {
      if (res.success) setDspLatest(res.data);
    }).catch(() => {});
  }, []);

  return (
    <div>
      <h1 style={{ marginBottom: 24 }}>Bảng điều khiển server</h1>

      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Card hoverable onClick={() => navigate('/devices')}>
            <Statistic
              title="Thiết bị"
              value={deviceStats.total || devices.length || 0}
              prefix={<ThunderboltOutlined />}
              valueStyle={{ color: '#00b96b' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card hoverable onClick={() => navigate('/devices')}>
            <Statistic
              title="Online"
              value={deviceStats.online || 0}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card hoverable onClick={() => navigate('/users')}>
            <Statistic
              title="Người dùng"
              value={userStats.total || 0}
              prefix={<TeamOutlined />}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card hoverable onClick={() => navigate('/firmware')}>
            <Statistic
              title="Firmware DSP latest"
              value={dspLatest?.version || '—'}
              prefix={<CloudUploadOutlined />}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic title="Offline" value={deviceStats.offline || 0} prefix={<PoweroffOutlined />} />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Lỗi / bảo trì"
              value={(deviceStats.error || 0) + (deviceStats.maintenance || 0)}
              prefix={<WarningOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic title="Công suất hiện tại" value={deviceStats.currentPower || 0} suffix="W" />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic title="Sản xuất hôm nay" value={deviceStats.dailyEnergy || 0} suffix="kWh" />
          </Card>
        </Col>
      </Row>

      <Card
        title="Thiết bị gần đây"
        extra={<Button type="link" onClick={() => navigate('/devices')}>Tất cả</Button>}
        style={{ marginTop: 24 }}
      >
        <Table
          rowKey={(row) => row.id || row.deviceId}
          size="small"
          pagination={false}
          dataSource={devices}
          columns={[
            { title: 'Tên', dataIndex: 'name' },
            { title: 'Device ID', dataIndex: 'deviceId' },
            {
              title: 'Trạng thái',
              dataIndex: 'status',
              render: (status) => (
                <Tag color={status === 'online' ? 'green' : status === 'error' ? 'red' : 'default'}>
                  {status || 'offline'}
                </Tag>
              ),
            },
            {
              title: 'MQTT',
              render: (_, row) => row.connection?.protocol || '—',
            },
            {
              title: 'PV (W)',
              render: (_, row) => row.currentData?.pvPower ?? row.currentData?.powerOutput ?? '—',
            },
          ]}
        />
      </Card>

      <Space style={{ marginTop: 24 }}>
        <Button type="primary" onClick={() => navigate('/devices')}>Quản lý thiết bị</Button>
        <Button onClick={() => navigate('/users')}>Quản lý user</Button>
        <Button onClick={() => navigate('/firmware')}>Firmware DSP</Button>
      </Space>
    </div>
  );
}
